import object from 'helpers/object'


export const initialState = {
  step: 'ticket',
  tickets: [],
  categories: [],
  stepData: null,
  isFetching: true,
}


export const setStep = (state, payload) => (
  object.setIn(state, [ 'step' ], payload)
)

export const setStepData = (state, payload) => (
  object.setIn(state, [ 'stepData' ], payload)
)

export const setTickets = (state, payload) => (
  object.setIn(state, [ 'tickets' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
